import { Dict } from '../../../../model/dict';

const ACTIVITY_DEFINITION_SECTOR_MAP: Dict<string[]> = {
  green: [
    'battery_electric_heavy_trucks',
    'battery_electric_light_trucks',
    'battery_electric_vehicles',
    'coal_freight_rail',
    'coal_passenger_rail',
    'diesel_buses',
    'diesel_heavy_trucks',
    'diesel_light_trucks',
    'diesel_passenger_rail',
    'diesel_rail_freight',
    'diesel_vehicles',
    'electric_bikes',
    'electric_bus',
    'electric_cargo_bikes',
    'electric_freight_transportation_by_air',
    'electric_motorcycles',
    'electric_passenger_transportation_by_air',
    'electric_rail',
    'electric_rail_freight',
    'electric_shipping_freight',
    'electric_shipping_passenger',
    'freight_transportation_by_air',
    'gas_buses',
    'gas_heavy_trucks',
    'gas_light_trucks',
    'gas_vehicles',
    'hydrogen_buses',
    'hydrogen_heavy_trucks',
    'hydrogen_light_trucks',
    'hydrogen_passenger_rail',
    'hydrogen_rail_freight',
    'hydrogen_vehicles',
    'lng_shipping_freight',
    'lng_shipping_passenger',
    'lpg_buses',
    'lpg_vehicles',
    'passenger_transportation_by_air',
    'petrol_buses',
    'petrol_heavy_trucks',
    'petrol_light_trucks',
    'petrol_motorcycles',
    'petrol_vehicles',
    'ship_freight',
    'ship_passenger',
    'tram_and_light_rail',
    'unspecified_emissions_from_aviation',
    'unspecified_emissions_from_waterborne_transport',
    'walking_cycling',
  ],
  blue: [
    'basic_oxygen_furnace_for_steel_production',
    'biogas_usage_within_chemical_industries',
    'biogas_usage_within_glass_industries',
    'biogas_usage_within_iron_and_steel_industries',
    'biogas_usage_within_pulp_paper_and_print_industries',
    'biomass_usage_within_chemical_industries',
    'biomass_usage_within_glass_industries',
    'biomass_usage_within_iron_and_steel_industries',
    'biomass_usage_within_pulp_paper_and_print_industries',
    'blast_furnace_gas_usage_within_iron_and_steel_industries',
    'blast_furnace_reduction_of_iron_ore_for_pig_iron_production',
    'calcination_for_glass_production',
    'calcination_for_sinter_production',
    'calcination_of_limestone_for_clinker_production',
    'calcination_of_limestone_for_lime_production',
    'cement_mineral_industries_biomass_usage',
    'cement_mineral_industries_coal_usage',
    'cement_mineral_industries_electricity_usage',
    'coal_usage_within_chemical_industries',
    'coal_usage_within_glass_industries',
    'coal_usage_within_iron_and_steel_industries',
    'coal_usage_within_pulp_paper_and_print_industries',
    'coke_oven_gas_usage_within_iron_and_steel_industries',
    'direct_reduction_of_iron_ore_for_steel_production',
    'electric_arc_furnace_for_steel_production',
    'electricity_usage_within_aluminium_industries',
    'electricity_usage_within_chemical_industries',
    'electricity_usage_within_electric_equipment_manufacturing',
    'electricity_usage_within_glass_industries',
    'electricity_usage_within_iron_and_steel_industries',
    'electricity_usage_within_pulp_paper_and_print_industries',
    'electrolysis_of_inert_anodes_for_aluminium_production',
    'fugitive_emissions_abandoned_coal_mines',
    'fugitive_emissions_coal_production_surface',
    'fugitive_emissions_coal_production_under_ground',
    'hydrogen_usage_within_chemical_industries',
    'hydrogen_usage_within_glass_industries',
    'hydrogen_usage_within_iron_and_steel_industries',
    'hydrogen_usage_within_pulp_paper_and_print_industries',
    'industrial_unregulated_biogas_use',
    'industrial_unregulated_biomass_use',
    'industrial_unregulated_coal_use',
    'industrial_unregulated_diesel_use',
    'industrial_unregulated_district_heat_use',
    'industrial_unregulated_electricity_use',
    'industrial_unregulated_gas_oil_use',
    'industrial_unregulated_gas_use',
    'industrial_unregulated_lpg_use',
    'industrial_unregulated_oil_use',
    'industrial_unregulated_petrol_use',
    'mobile_machinery_biofuel',
    'mobile_machinery_diesel',
    'mobile_machinery_electricity',
    'mobile_machinery_lpg',
    'mobile_machinery_petrol',
    'natural_gas_usage_within_chemical_industries',
    'natural_gas_usage_within_glass_industries',
    'natural_gas_usage_within_iron_and_steel_industries',
    'natural_gas_usage_within_pulp_paper_and_print_industries',
    'oil_usage_within_chemical_industries',
    'oil_usage_within_glass_industries',
    'oil_usage_within_pulp_paper_and_print_industries',
    'open_hearth_furnace_for_steel_production',
    'prebaked_carbon_anodes_electrolysis_for_aluminium_production',
    'reforming_of_methane_for_ammonia_production',
    'unspecified_consumption_based_emissions',
    'unspecified_emissions_from_industrial_processes',
    'unspecified_emissions_from_large_scale_industrial',
  ],
  orange: [
    'unspecified_emissions_from_aggregate_sources_and_non_co2_emission_sources_on_land',
    'unspecified_emissions_from_cropland',
    'unspecified_emissions_from_forest_land',
    'unspecified_emissions_from_grassland',
    'unspecified_emissions_from_land',
    'unspecified_emissions_from_livestock',
    'unspecified_emissions_from_manure_management',
    'unspecified_emissions_from_settlements',
    'unspecified_emissions_from_wetlands',
  ],
  pink: [
    'agriculture_forestry_fishing_unregulated_biogas_use',
    'agriculture_forestry_fishing_unregulated_biomass_use',
    'agriculture_forestry_fishing_unregulated_coal_use',
    'agriculture_forestry_fishing_unregulated_diesel_use',
    'agriculture_forestry_fishing_unregulated_district_heat_use',
    'agriculture_forestry_fishing_unregulated_electricity_use',
    'agriculture_forestry_fishing_unregulated_gas_oil_use',
    'agriculture_forestry_fishing_unregulated_gas_use',
    'agriculture_forestry_fishing_unregulated_lpg_use',
    'agriculture_forestry_fishing_unregulated_oil_use',
    'agriculture_forestry_fishing_unregulated_petrol_use',
    'commercial_building_cooling_with_ac',
    'commercial_building_cooling_with_district_cooling',
    'commercial_building_heating_with_biogas',
    'commercial_building_heating_with_coal',
    'commercial_building_heating_with_direct_electric_heaters',
    'commercial_building_heating_with_district_heating',
    'commercial_building_heating_with_gas',
    'commercial_building_heating_with_gas_oil',
    'commercial_building_heating_with_heatpump',
    'commercial_building_heating_with_hydrogen',
    'commercial_building_heating_with_lpg',
    'commercial_building_heating_with_oil',
    'commercial_building_heating_with_solar_thermal',
    'commercial_building_heating_with_solid_biofuels',
    'commercial_unregulated_biogas_use',
    'commercial_unregulated_biomass_use',
    'commercial_unregulated_coal_use',
    'commercial_unregulated_diesel_use',
    'commercial_unregulated_district_heat_use',
    'commercial_unregulated_electricity_use',
    'commercial_unregulated_gas_oil_use',
    'commercial_unregulated_gas_use',
    'commercial_unregulated_lpg_use',
    'commercial_unregulated_oil_use',
    'commercial_unregulated_petrol_use',
    'heating_of_new_commercial_buildings',
    'heating_of_new_industrial_buildings',
    'heating_of_new_public_buildings',
    'heating_of_new_residential_multi_family_buildings',
    'heating_of_new_residential_single_family_buildings',
    'industrial_building_cooling_with_ac',
    'industrial_building_cooling_with_district_cooling',
    'industrial_building_heating_with_coal',
    'industrial_building_heating_with_direct_electric_heaters',
    'industrial_building_heating_with_district_heating',
    'industrial_building_heating_with_gas',
    'industrial_building_heating_with_gas_oil',
    'industrial_building_heating_with_heatpump',
    'industrial_building_heating_with_hydrogen',
    'industrial_building_heating_with_lpg',
    'industrial_building_heating_with_oil',
    'industrial_building_heating_with_solar_thermal',
    'industrial_building_heating_with_solid_biofuels',
    'institutional_electric_street_lighting',
    'institutional_unregulated_biogas_use',
    'institutional_unregulated_biomass_use',
    'institutional_unregulated_coal_use',
    'institutional_unregulated_diesel_use',
    'institutional_unregulated_district_heat_use',
    'institutional_unregulated_electricity_use',
    'institutional_unregulated_gas_oil_use',
    'institutional_unregulated_gas_use',
    'institutional_unregulated_lpg_use',
    'institutional_unregulated_oil_use',
    'institutional_unregulated_petrol_use',
    'multi_family_building_cooling_with_ac',
    'multi_family_building_cooling_with_district_cooling',
    'multi_family_building_heating_with_coal',
    'multi_family_building_heating_with_direct_electric',
    'multi_family_building_heating_with_district_heating',
    'multi_family_building_heating_with_gas',
    'multi_family_building_heating_with_heatpump',
    'multi_family_building_heating_with_hydrogen',
    'multi_family_building_heating_with_lpg',
    'multi_family_building_heating_with_oil',
    'multi_family_building_heating_with_solar_thermal',
    'multi_family_building_heating_with_solid_biofuels',
    'non_residential_commercial_low_carbon_construction',
    'non_residential_commercial_standard_construction',
    'public_building_cooling_with_ac',
    'public_building_cooling_with_district_cooling',
    'public_building_heating_with_coal',
    'public_building_heating_with_direct_electric_heaters',
    'public_building_heating_with_district_heating',
    'public_building_heating_with_gas',
    'public_building_heating_with_gas_oil',
    'public_building_heating_with_heatpump',
    'public_building_heating_with_hydrogen',
    'public_building_heating_with_lpg',
    'public_building_heating_with_oil',
    'public_building_heating_with_solar_thermal',
    'public_building_heating_with_solid_biofuels',
    'remote_working',
    'residential_electric_cooking_stoves',
    'residential_gas_cooking_stoves',
    'residential_multi_family_low_carbon_construction',
    'residential_multi_family_standard_construction',
    'residential_unregulated_biogas_use',
    'residential_unregulated_biomass_use',
    'residential_unregulated_coal_use',
    'residential_unregulated_diesel_use',
    'residential_unregulated_district_heat_use',
    'residential_unregulated_electricity_use',
    'residential_unregulated_gas_use',
    'residential_unregulated_lpg_use',
    'residential_unregulated_oil_use',
    'residential_unregulated_petrol_use',
    'single_family_building_cooling_with_ac',
    'single_family_building_cooling_with_district_cooling',
    'single_family_building_heating_with_coal',
    'single_family_building_heating_with_direct_electric_heaters',
    'single_family_building_heating_with_district_heating',
    'single_family_building_heating_with_gas',
    'single_family_building_heating_with_heatpump',
    'single_family_building_heating_with_hydrogen',
    'single_family_building_heating_with_lpg',
    'single_family_building_heating_with_oil',
    'single_family_building_heating_with_solar_thermal',
    'single_family_building_heating_with_solid_biofuels',
  ],
  yellow: [
    'biofuel_fired_powerplants',
    'biogas_usage_within_hydrogen_refinement',
    'biogas_use_non_specified_sources',
    'biomass_usage_within_hydrogen_refinement',
    'biomass_usage_within_petroleum_refinement',
    'biomass_use_non_specified_sources',
    'chp_biofuels',
    'chp_biogas',
    'chp_coal',
    'chp_hydrogen',
    'chp_landfill_gas',
    'chp_natural_gas',
    'chp_oil',
    'chp_sludge',
    'chp_waste_incineration',
    'coal_fired_power_plants',
    'coal_usage_within_hydrogen_refinement',
    'coal_use_non_specified_sources',
    'crude_oil_usage_within_petroleum_refinement',
    'diesel_use_non_specified_sources',
    'district_heat_use_non_specified_sources',
    'district_heating_biofuel',
    'district_heating_biogas',
    'district_heating_coal',
    'district_heating_geothermal_heat',
    'district_heating_heat_pumps',
    'district_heating_hydrogen',
    'district_heating_landfill_gas',
    'district_heating_natural_gas',
    'district_heating_oil',
    'district_heating_residual_heat',
    'district_heating_sludge',
    'district_heating_solar_thermal',
    'district_heating_waste',
    'district_heating_water_sourced_heat_pumps',
    'electricity_coal',
    'electricity_power_plant_gas',
    'electricity_power_plant_oil',
    'electricity_usage_within_hydrogen_refinement',
    'electricity_usage_within_petroleum_refinement',
    'electricity_use_non_specified_sources',
    'flaring_gas_and_oil_production_wtt',
    'fuel_oil_use_non_specified_sources',
    'fugitive_emissions_gas_distribution',
    'gas_fired_power_plants',
    'gas_use_non_specified_sources',
    'gasification_of_carbon_for_hydrogen_production',
    'grid_current',
    'grid_future',
    'hydro_reservoir',
    'hydrogen_fired_power_plants',
    'imported_grid',
    'imported_grid_district_heat',
    'lpg_use_non_specified_sources',
    'natural_gas_usage_within_hydrogen_refinement',
    'oil_fired_power_plants',
    'petrol_use_non_specified_sources',
    'reforming_of_methane_for_hydrogen_production',
    'roof_top_solar_domestic',
    'sludge_fired_power_plants',
    'solar_parks',
    'solar_rooftops',
    'venting_gas_and_oil_production_wtt',
    'waste_fired_power_plants',
    'wind_offshore',
    'wind_onshore',
  ],
  teal: [
    'composting_of_organic_waste',
    'fermentation_of_organic_waste',
    'incineration_and_open_burning_of_waste',
    'open_burning_of_waste',
    'recycling_of_solid_waste',
    'solid_waste_disposal_in_landfills_and_open_dumps_etc',
    'unspecified_emissions_from_biological_treatment_of_waste',
    'unspecified_emissions_from_disposal_of_solid_waste',
    'unspecified_emissions_from_incineration_and_open_burning_of_waste',
    'unspecified_emissions_from_wastewater_management',
    'waste_exported_for_anaerobic_digestion',
    'waste_exported_for_composting',
    'waste_exported_for_disposal_in_landfills',
    'waste_exported_for_incineration',
    'waste_exported_for_open_burning',
    'wastewater_treatment_and_discharge',
    'wastwater_exported_for_treatment',
  ],
};

export const ACTIVITY_DEFINITION_SECTOR_MAP_REVERSE: Dict<string> = Object.keys(ACTIVITY_DEFINITION_SECTOR_MAP).reduce(
  (acc: { [key: string]: string }, sector) => {
    ACTIVITY_DEFINITION_SECTOR_MAP[sector].forEach((activity) => {
      acc[activity] = sector as string;
    });
    return acc;
  },
  {}
);
